<template>
	<button v-if="enabled" v-tooltip="{ content: content.toggleFullscreen, classes: 'last' }"
		:aria-label="content.toggleFullscreen" :class="{ selected: isFullscreen , customMobile: isMetro}" class="fullscreen-toggle btn"
		data-tour-item="fullscreen" tabindex="0" @click="handleFullScreen" v-bind="config.attrs">

		<div v-if="!isFullscreen">
			<svg role="img" class="default-fullscreen" viewBox="189.985 -40.354 14.394 15" width="16.394" height="17"
				xmlns="http://www.w3.org/2000/svg" aria-labelledby="fullscreenDefault">
				<title id="fullscreenDefault">Toggle fullscreen</title>
				<path
					d="M 204.379 -39.739 C 204.379 -40.082 204.107 -40.354 203.764 -40.354 L 198.232 -40.354 C 197.882 -40.354 197.622 -40.078 197.622 -39.729 C 197.622 -39.379 197.882 -39.123 198.232 -39.123 L 203.148 -39.123 L 203.138 -34.184 C 203.138 -33.835 203.404 -33.568 203.754 -33.568 C 204.103 -33.569 204.369 -33.835 204.369 -34.184 L 204.379 -39.729 C 204.379 -39.731 204.379 -39.732 204.379 -39.734 C 204.379 -39.736 204.379 -39.737 204.379 -39.739 Z" />
				<path
					d="M 196.132 -26.585 L 191.216 -26.585 L 191.216 -31.51 C 191.216 -31.858 190.95 -32.125 190.6 -32.125 C 190.252 -32.125 189.985 -31.859 189.985 -31.51 L 189.985 -25.979 C 189.985 -25.977 189.985 -25.975 189.985 -25.974 C 189.985 -25.972 189.985 -25.971 189.985 -25.969 C 189.985 -25.626 190.257 -25.354 190.6 -25.354 L 196.132 -25.354 C 196.481 -25.354 196.742 -25.629 196.742 -25.979 C 196.742 -26.328 196.481 -26.585 196.132 -26.585 Z" />
			</svg>
			<svg role="img" class="rollover-fullscreen" viewBox="208 -22 25.757 24.771" width="29.757" height="22.771"
				xmlns="http://www.w3.org/2000/svg" aria-labelledby="fullscreenRollover">
				<title id="fullscreenRollover">Toggle fullscreen Hover</title>
				<path
					d="M 233.757 -21.385 C 233.757 -21.728 233.485 -22 233.142 -22 L 227.61 -22 C 227.26 -22 227 -21.724 227 -21.375 C 227 -21.025 227.26 -20.769 227.61 -20.769 L 232.526 -20.769 L 232.516 -15.83 C 232.516 -15.481 232.782 -15.214 233.132 -15.214 C 233.481 -15.215 233.747 -15.481 233.747 -15.83 L 233.757 -21.375 C 233.757 -21.377 233.757 -21.378 233.757 -21.38 C 233.757 -21.382 233.757 -21.383 233.757 -21.385 Z" />
				<path
					d="M 214.147 1.54 L 209.231 1.54 L 209.231 -3.385 C 209.231 -3.733 208.965 -4 208.615 -4 C 208.267 -4 208 -3.734 208 -3.385 L 208 2.146 C 208 2.148 208 2.15 208 2.151 C 208 2.153 208 2.154 208 2.156 C 208 2.499 208.272 2.771 208.615 2.771 L 214.147 2.771 C 214.496 2.771 214.757 2.496 214.757 2.146 C 214.757 1.797 214.496 1.54 214.147 1.54 Z" />
				<g transform="matrix(1, 0, 0, 1, -19.728729248046875, -20.961776733398438)">
					<ellipse style="stroke: rgb(0, 0, 0); fill: rgb(64, 13, 13);" cx="236.128" cy="16.201" rx="0.6"
						ry="0.6" />
					<ellipse style="stroke: rgb(0, 0, 0); fill: rgb(64, 13, 13);" cx="240.444" cy="11.577" rx="0.6"
						ry="0.6" />
					<ellipse style="stroke: rgb(0, 0, 0); fill: rgb(64, 13, 13);" cx="245" cy="7" rx="0.6" ry="0.6" />
				</g>
			</svg>
		</div>
		<div v-else>
			<svg role="img" class="default-fullscreen" viewBox="186 71 20.757 18.771" width="19.757" height="17.771"
				xmlns="http://www.w3.org/2000/svg" aria-labelledby="exitfullscreen">
				<title id="exitFullscreen">Exit fullscreen</title>
				<path
					d="M 206.757 71.615 C 206.757 71.272 206.485 71 206.142 71 L 200.61 71 C 200.26 71 200 71.276 200 71.625 C 200 71.975 200.26 72.231 200.61 72.231 L 205.526 72.231 L 205.516 77.17 C 205.516 77.519 205.782 77.786 206.132 77.786 C 206.481 77.785 206.747 77.519 206.747 77.17 L 206.757 71.625 C 206.757 71.623 206.757 71.622 206.757 71.62 C 206.757 71.618 206.757 71.617 206.757 71.615 Z"
					style="transform-origin: 203.379px 74.393px;"
					transform="matrix(-1, 0, 0, -1, -0.000030517578, -0.000015258789)" />
				<path
					d="M 192.147 88.54 L 187.231 88.54 L 187.231 83.615 C 187.231 83.267 186.965 83 186.615 83 C 186.267 83 186 83.266 186 83.615 L 186 89.146 C 186 89.148 186 89.15 186 89.151 C 186 89.153 186 89.154 186 89.156 C 186 89.499 186.272 89.771 186.615 89.771 L 192.147 89.771 C 192.496 89.771 192.757 89.496 192.757 89.146 C 192.757 88.797 192.496 88.54 192.147 88.54 Z"
					style="transform-origin: 189.379px 86.3855px;" transform="matrix(-1, 0, 0, -1, 0, 0)" />
				<ellipse style="stroke: rgb(0, 0, 0); fill: rgb(64, 13, 13);" cx="196.507" cy="80.24" rx="0.6" ry="0.6" />
			</svg>

			<svg role="img" class="rollover-fullscreen exit" viewBox="195 171 15.757 15.771" width="15.757" height="15.771"
				xmlns="http://www.w3.org/2000/svg" aria-labelledby="exitRollover">
				<title id="exitRollover">Exit fullscreen Hover</title>
				<path
					d="M 210.756 171.615 C 210.756 171.272 210.484 171 210.141 171 L 204.609 171 C 204.259 171 203.999 171.276 203.999 171.625 C 203.999 171.975 204.259 172.231 204.609 172.231 L 209.525 172.231 L 209.515 177.17 C 209.515 177.519 209.781 177.786 210.131 177.786 C 210.48 177.785 210.746 177.519 210.746 177.17 L 210.756 171.625 C 210.756 171.623 210.756 171.622 210.756 171.62 C 210.756 171.618 210.756 171.617 210.756 171.615 Z"
					style="transform-origin: 207.378px 174.393px;"
					transform="matrix(-1, 0, 0, -1, 0.000030517578, -0.000030517578)" />
				<path
					d="M 201.146 185.539 L 196.23 185.539 L 196.23 180.614 C 196.23 180.266 195.964 179.999 195.614 179.999 C 195.266 179.999 194.999 180.265 194.999 180.614 L 194.999 186.145 C 194.999 186.147 194.999 186.149 194.999 186.15 C 194.999 186.152 194.999 186.153 194.999 186.155 C 194.999 186.498 195.271 186.77 195.614 186.77 L 201.146 186.77 C 201.495 186.77 201.756 186.495 201.756 186.145 C 201.756 185.796 201.495 185.539 201.146 185.539 Z"
					style="transform-origin: 198.378px 183.385px;" transform="matrix(-1, 0, 0, -1, 0, -0.000030517578)" />
			</svg>
			
		</div>
		<span class="panel-label">{{ !isFullscreen ? content.walkthrough.fullscreen.title : content.exitFullscreen }}</span>
		<!-- <svg v-if="!isFullscreen" height="18" viewBox="0 0 14 14" width="18" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 9H0v5h5v-2H2V9zM0 5h2V2h3V0H0v5zm12 7H9v2h5V9h-2v3zM9 0v2h3v3h2V0H9z" fill="currentColor"
			      fill-rule="nonzero"/>
		</svg>
		
		<svg v-else height="18" viewBox="0 0 14 14" width="18" xmlns="http://www.w3.org/2000/svg">
			<path d="M3 14h2V9H0v2h3v3zM5 0H3v3H0v2h5V0zm6 11h3V9H9v5h2v-3zm3-6V3h-3V0H9v5h5z" fill="currentColor"/>
		</svg> -->
	</button>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "ToggleFullscreenButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'fullScreen'
		}
	},
	mounted() {
		if (this.config?.trigger !== 'internal') {
			document.addEventListener('keydown', this.onEscape)
		}
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onEscape);
	},
	computed: {
		...mapGetters(["content"]),
		...mapState('screen', ['fullScreenToggle']),
		...mapGetters('screen', ['isFullscreen']),
		...mapGetters(['isMetro']),
	},
	methods: {
		...mapActions('screen', ['toggleFullScreen', "setFullScreenState"]),
		onEscape(e) {
			//console.log('Key Press:', e)
			if (e.key === 'Escape') this.setFullScreenState(false);
		},
		handleFullScreen() {
			this.toggleFullScreen();
			this.$root.$emit('dropdown-hidden-updated', this.$parent.isHidden)
			this.$parent.isHidden = !this.$parent.isHidden
		}
	}
}
</script>

<style lang="scss" scoped>
[mode="desktop"] {
	button.fullscreen-toggle {
		min-width: 90px;
	  
		div {
			margin-top: 4px;
			.rollover-fullscreen {
				min-height: 22px;
			}
		}
	}
}
button.fullscreen-toggle {
	&.selected {
		background: unset !important;
		color: unset !important;
	}

	&:hover {
		color: var(--secondary-color) !important;

		.default-fullscreen {
			display: none;
		}

		.rollover-fullscreen {
			display: block;

			g ellipse {
				stroke: var(--secondary-color) !important;
				fill: var(--secondary-color) !important;
			}

			path {
                fill: var(--secondary-color) !important
			}
		}
	}
    .default-fullscreen {
		display: block;
	}
    .rollover-fullscreen {
		display: none;

	}
    svg path,
	button svg ellipse {
		fill: #545454;
	}
}

[mode="desktop"] {
	.default-fullscreen {
		margin-bottom: 5px;
	}

}
[mode="mobile"] {
	button.customMobile{
		margin-left: 7px;
	}

}</style>
